/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Entity from 'fierry/flux/entity'


export default class extends Entity
{
  constructor(dependences, state)
  {
    super(dependences);

    this.state = state;
  }


  getState ()
  {
    return this.state;
  }


};
